let config = {}

if (window.dbsProductsReviewsConfig) {
  config = {
    manufacturerId: window.dbsProductsReviewsConfig.manufacturerId
  }
}

export const ManufacturerPageConfig = config



// WEBPACK FOOTER //
// ./src/config/manufacturerPageConfig.js